<script setup lang="ts">
import type { MenuItemProps } from "ls/components/primitives/menu/types";
import MenuItem from "ls/components/primitives/menu/MenuItem.vue";

const props = defineProps<MenuItemProps>();
</script>

<template>
  <MenuItem
    v-bind="props"
    tabindex="-1"
    role="menuitem"
  >
    <template v-for="(_, slot) of $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </MenuItem>
</template>
